import { BannerType, BannerTypeValue } from './banner-type.js'

import dismissBannerIcon from '../../assets/imgs/close-icon.svg'
import errorBannerIcon from '../../assets/imgs/error-banner-icon.svg'
import infoBannerIcon from '../../assets/imgs/info-icon.svg'
import successBannerIcon from '../../assets/imgs/check_circle_outline.svg'
import warnBannerIcon from '../../assets/imgs/alert.svg'

import './status-banner.css'

export const StatusBanner = ({
  type,
  message,
  onDismissClick,
}: {
  type: BannerTypeValue
  message: string
  onDismissClick: () => void
}) => {
  return (
    <div className={`banner ${type}`}>
      {type !== BannerType.ERROR ? null : (
        <img
          className="banner-icon"
          src={errorBannerIcon}
          alt="red exclamation point inside a red circle"
        />
      )}
      {type !== BannerType.INFO ? null : (
        <img
          className="banner-icon"
          src={infoBannerIcon}
          alt="red exclamation point inside a red circle"
        />
      )}
      {type !== BannerType.SUCCESS ? null : (
        <img
          className="banner-icon"
          src={successBannerIcon}
          alt="green checkmark inside a green circle"
        />
      )}
      {type !== BannerType.WARNING ? null : (
        <img
          className="banner-icon"
          src={warnBannerIcon}
          alt="orange exclamation point inside a orange circle"
        />
      )}
      <div className={`banner-text ${type}`}>{message}</div>
      <button
        onClick={(event) => {
          event.preventDefault()
          onDismissClick()
        }}
        className="dismiss-banner"
      >
        <img className="dismiss-banner-icon" src={dismissBannerIcon} alt="X" />
      </button>
    </div>
  )
}
